/**
 * CMS requires a non-empty alt. Editors mark decorative images with ".".
 * Frontend maps that marker to an empty alt so assistive tech skips the image.
 */

// CMS data is untyped at runtime: alt can arrive as a number, a localized
// object, or another non-string value. Only strings are valid alt text.
function normalizeAlt(alt: unknown): string {
  return typeof alt === "string" ? alt.trim() : "";
}

export function isDecorativeAlt(alt?: unknown): boolean {
  const trimmed = normalizeAlt(alt);
  return trimmed === "" || trimmed === ".";
}

export function resolveImageAlt(alt?: unknown): string {
  return isDecorativeAlt(alt) ? "" : normalizeAlt(alt);
}

export function getAccessibleImageProps(alt?: unknown): {
  alt: string;
  "aria-hidden"?: true;
} {
  if (isDecorativeAlt(alt)) {
    return { alt: "", "aria-hidden": true };
  }

  return { alt: normalizeAlt(alt) };
}
